import { React, useState, useEffect } from "react";
import imgstyle from "./imgcomp.module.css";
import ModalGallery from "./ModalGallery";
import axios from "axios";
import { useUser } from "../../storage/UserContext"; // Import the context hook

const apiUrl = process.env.REACT_APP_URL;

const ImgComp = ({ isEditable, username }) => {
  const { userData, setUserData } = useUser(); // Use context hook
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (!username) {
      return;
    }

    const fetchUserImages = async () => {
      try {
        const response = await axios.get(`${apiUrl}/media/${username}?qty=10`, {
          withCredentials: true,
        });

        if (response.status === 200) {
          setImages(response.data.images || []);
        } else {
          console.error("Failed to fetch user images");
        }
      } catch (error) {
        console.error("Error fetching user images:", error);
      }
    };

    fetchUserImages();
  }, [username, userData]);

  const handleDeleteImage = async (img_id) => {
    try {
      const response = await axios.delete(`${apiUrl}/media/delete/${img_id}`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        const updatedImages = userData.images.filter(
          (img) => img.img_id !== img_id
        );
        setUserData((prevData) => ({
          ...prevData,
          images: updatedImages,
        }));
      } else {
        console.error("Failed to delete the image. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div className={imgstyle.mainImgStyle}>
      <h2>Images</h2>
      {images.length > 0 ? (
        <div className={imgstyle.gallery}>
          {/* Display the first 4 images from the user's images */}
          {images.slice(0, 4).map((img) => (
            <figure key={img.img_id} className={imgstyle.figure}>
              <img src={img.url} alt={`img-${img.img_id}`} />
            </figure>
          ))}
          <ModalGallery
            userImages={images}
            handleDeleteImage={handleDeleteImage}
            isEditable={isEditable}
          />
        </div>
      ) : (
        <p className={imgstyle.noImgToDisplay}>No images to display</p>
      )}
    </div>
  );
};

export default ImgComp;
